import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

// import clientService from '../services/clientService';

interface DialogProps {
  id: number;
  title: string;
  open: boolean;
  action: () => void;
  handler: () => void;
  description: string;
  cancelButtonText: string;
  confirmButtonText: string;
}

export default function ProductDialog(props: DialogProps) {
  return (
    <div>
      <Dialog
        key={props.id}
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handler} sx={{ color: "red" }}>
            {props.cancelButtonText}
          </Button>
          <Button onClick={props.action} autoFocus>
            {props.confirmButtonText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
